import * as React from "react";

export function Progress({ value, className }) {
  return (
    <div
      className={`w-full h-2 bg-gray-200 rounded-full overflow-hidden ${className || ""}`}
    >
      <div
        className="h-full bg-blue-600 transition-all duration-300"
        style={{ width: `${value}%` }}
      />
    </div>
  );
}
